import axios from "axios";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class WaterSportsService {

  static getWaterSports(item) {

    let api = '';
    
    if(item?.id){
        api= `${API_BASE_URL}${API_PATHS.waterSports}?id=${item?.id}`
     }
     else 
    api = `${API_BASE_URL}${API_PATHS.waterSports}`;
    
      return axios
       .get(api,item)
       .then((response) => {
         if (response.data) {
         }
         return response.data;
       })
       .catch((error) => {
         console.error("Error:", error);
         throw error;
       });
   }

  
}

export default WaterSportsService;